import idb from '~/app/idb'

export default {
  ACTIVE: 'active',
  set (key, value) {
    return idb.save(idb.REGISTRY, { key, value }, false)
  },
  get (key) {
    return idb.get(idb.REGISTRY, key)
  }
}
